import { Button, Card, Form, Spinner, Row, Col } from "react-bootstrap";
import { IItem } from "../../api/types";
import { usePutItemMutation } from "../../api/putItem.mutation";
import { useEffect, useRef, useState } from "react";
import { WarehouseSelector } from "./WarehouseSelector";

const DEFAULTS: Partial<IItem> = {
  quantity: 1,
}

export const ItemForm = (props: { item?: IItem, onSave?: (item: IItem) => void, onClose: () => void }) => {
  const { item: itemInput } = props;
  const [item, setItem] = useState<Partial<IItem>>({ ...DEFAULTS, ...itemInput });
  const { mutate: putItem, isPending, isError, isSuccess } = usePutItemMutation();
  const inputRef = useRef<HTMLInputElement>(null);
  const updateField = (key: keyof IItem, value: any) => setItem({ ...item, [key]: value });

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const onSubmit: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault()
    if (props.onSave) {
      props.onSave(item as IItem);
    } else {
      putItem(item as IItem);
    }
    props.onClose();
  }

  if (isSuccess) props.onClose();

  const expiration = item?.expiration ? new Date(item?.expiration) : undefined;
  let year = undefined
  let month = undefined; // Month is 0-indexed
  let day = undefined;
  if (expiration) {
    year = expiration.getUTCFullYear();
    month = String(expiration.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    day = String(expiration.getUTCDate()).padStart(2, '0');
  }

  return <Card>
    <Card.Header>
      {item?.id ? "Edit Item" : "Create Item"}
    </Card.Header>
    <Card.Body>
      <Form>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column xs={4}>Item Name</Form.Label>
          <Col xs={8}>
            <Form.Control
              type="text" placeholder="Item Name"
              defaultValue={item?.name}
              onChange={(e) => updateField('name', e.target.value)}
              ref={inputRef}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column xs={4}>Warehouse</Form.Label>
          <Col xs={8}>
            <WarehouseSelector
              value={item?.warehouseId}
              onChange={(warehouseId) => updateField('warehouseId', warehouseId)}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column xs={4}>Quantity</Form.Label>
          <Col xs={8}>
            <Form.Control
              type="number" placeholder="Quantity"
              defaultValue={item?.quantity}
              onChange={(e) => updateField('quantity', parseInt(e.target.value))}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column xs={4}>Cost</Form.Label>
          <Col xs={8}>
            <Form.Control
              type="number" step="0.01" placeholder="Cost"
              defaultValue={item?.cost}
              onChange={(e) => updateField('cost', parseFloat(e.target.value))}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column xs={4}>Expiration</Form.Label>
          <Col xs={8}>
            <Form.Control
              type="date" placeholder="Expiration Date"
              defaultValue={expiration ? `${year}-${month}-${day}` : undefined}
              onChange={(e) => updateField('expiration', (new Date(e.target.value+'UTC') as unknown as number * 1))}
            />
          </Col>
        </Form.Group>
      </Form>
    </Card.Body>
    <Card.Footer>
      {isError && <Card.Text className="text-danger">Error</Card.Text>}
      {isPending ? <Spinner /> :
        <Button onClick={onSubmit}>{item?.id ? "Update" : "Create"}</Button>
      }
    </Card.Footer>
  </Card>
}